import React from "react";
import img from "../images/Pattu2.png";
import img8 from "../images/Pattu banner.png";

const Pattu = () => {
  return (
    <div className=" bg-white">
      <h2 className="font-abhaya text-xl md:text-3xl lg:text-4xl text-center font-bold text-secondary tracking-wide mb-6">
        Pattu Pavada
      </h2>

     <div className="w-full lg:w-1/3">
  <div className="relative h-full aspect-[3/4] block 3xl:hidden">
    <img
      src={img}
      alt="Main Dress"
      className="w-full h-full px-3 object-cover rounded-lg shadow-md"
    />

    {/* Make the anchor itself the positioned button (no extra wrapper) */}
    <a
      href="https://api.whatsapp.com/send?phone=919363799534&text=I%20am%20interested%20to%20buy%20to%20New%20%20Arrival%20%20Collection%20%20Please%20show%20more%20collection."
      target="_blank"
      rel="noopener noreferrer"
      className="
        absolute bottom-4 left-1/2 z-20
        -translate-x-1/2
        inline-flex items-center justify-center
        font-Belanosima font-semibold
        py-1 px-4
        rounded-md shadow
        border-2 border-[#f4a420]
        text-[#f4a420]
        bg-black/40
        hover:bg-[#f4a420] hover:text-white
        transition
        block 3xl:hidden
      "
    >
      Explore
    </a>
  </div>
</div>


      <div className="relative hidden 3xl:block">
        <img
          src={img8}
          alt="Shop Banner"
          className=" w-full h-[380px] 5xl:h-[500px] 8xl:h-[550px] 10xl:h-[840px] 11xl:h-[930px] hidden 3xl:block"
        />

        {/* Example: place overlay slightly left-of-center and below that wording */}
        <div className="absolute left-[30%] top-[70%] -translate-x-1/2 -translate-y-1/2 z-20 pointer-events-none">
          <a
            href="https://api.whatsapp.com/send?phone=919363799534&text=I%20am%20interested..."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block pointer-events-auto bg-[#000] bg-opacity-55 font-Belanosima font-semibold py-2 px-6 rounded-md shadow border-2 border-[#f4a420] text-[#f4a420] hover:bg-[#f4a420] hover:text-white transition"
          >
            Explore Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default Pattu;
